import { defineMessages } from "react-intl";

const messages = defineMessages({
  confirmChanges: {
    id: "fileStorage.components.table.confirmChanges",
    defaultMessage: "Confirm Changes?",
  },
  confirmChangesMessage: {
    id: "fileStorage.components.table.confirmChangesMessage",
    defaultMessage:
      "Please confirm that you want to change the status of this application.",
  },
  cancel: {
    id: "fileStorage.components.table.cancel",
    defaultMessage: "Cancel",
  },
  submit: {
    id: "fileStorage.components.table.submit",
    defaultMessage: "Submit",
  },
});

export default messages;
